import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="scroll-section py-16 sm:py-20 border-t border-[#f0ebe0]/10">
      <div className="max-w-4xl mx-auto px-6 sm:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-center space-y-8"
        >
          <p 
            className="text-2xl sm:text-3xl md:text-4xl italic tracking-wide"
            style={{ fontFamily: 'EB Garamond, serif', color: '#f0ebe0' }}
          >
            Many ways to arrive. One place to sit.
          </p>
          
          <div className="pt-8">
            <div 
              className="font-mono text-sm tracking-[0.2em] uppercase opacity-55"
              style={{ color: '#f0ebe0' }}
            >
              THE SECOND SEAT
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;